import { render, staticRenderFns } from "./MarshalSummary.vue?vue&type=template&id=9193ea88&scoped=true"
import script from "./MarshalSummary.vue?vue&type=script&lang=js"
export * from "./MarshalSummary.vue?vue&type=script&lang=js"
import style0 from "./MarshalSummary.vue?vue&type=style&index=0&id=9193ea88&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9193ea88",
  null
  
)

export default component.exports